
export default {
  name: 'BaseVideoPlayer',
  props: {
    id: {
      type: String,
      required: false,
      default: 'base-player',
    },
    src: {
      required: true,
      type: String,
    },
    allow: {
      required: false,
      type: String,
      default:
        'clipboard-write; encrypted-media; gyroscope; picture-in-picture',
    },
    allowFullscreen: {
      required: false,
      type: Boolean,
      default: true,
    },
    containerStyles: {
      default: null,
      type: String,
    },
    playerStyles: {
      default: null,
      type: String,
    },
    autoplay: {
      required: false,
      type: Boolean,
      default: false,
    },
    loop: {
      required: false,
      type: Boolean,
      default: false,
    },
    muted: {
      required: false,
      type: Boolean,
      default: false,
    },
    poster: {
      required: false,
      type: String,
      default: null,
    },
    preload: {
      required: false,
      type: String,
      default: 'auto',
    },
  },
  data() {
    return {
      isValidUrl: true,
      urlType: 'iframe',
    }
  },
  watch: {
    src() {
      this.getVideoUrl(this.src)
    },
  },
  methods: {
    getVideoUrl(url) {
      if (!url) return null
      const vk = /(?:https?:\/\/(?:www\.)?)?vk.com\/video_ext.php/

      const ok = /(?:https?:\/\/(?:www\.)?)?ok.ru\/(?:video\/|)(\d+)(?:$|\/|\?)/

      const rutube =
        /(?:https?:\/\/(?:www\.)?)?rutube.ru\/(?:video\/|)(\w+)(?:$|\/|\?)/

      const vimeo =
        /(?:https?:\/\/(?:www\.)?)?vimeo.com\/(?:channels\/|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/

      const youtube =
        /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/

      const isValidYoutubeUrl = url.match(youtube)

      if (isValidYoutubeUrl) {
        this.urlType = 'iframe'
        this.isValidUrl = true
        this.$emit(
          'poster',
          `https://img.youtube.com/vi/${isValidYoutubeUrl[1]}/maxresdefault.jpg`
        )
        return 'https://www.youtube.com/embed/' + isValidYoutubeUrl[1]
      }

      const isValidVimeoUrl = url.match(vimeo)

      if (isValidVimeoUrl) {
        this.urlType = 'iframe'
        this.isValidUrl = true

        return 'https://player.vimeo.com/video/' + isValidVimeoUrl[3]
      }

      const isValidRutubeUrl = url.match(rutube)

      if (isValidRutubeUrl) {
        this.urlType = 'iframe'
        this.isValidUrl = true
        return 'https://rutube.ru/embed/' + isValidRutubeUrl[1]
      }

      const isValidOkUrl = url.match(ok)

      if (isValidOkUrl) {
        this.urlType = 'iframe'
        this.isValidUrl = true
        return 'https://ok.ru/videoembed/' + isValidOkUrl[1]
      }

      const isValidVkUrl = url.match(vk)

      if (isValidVkUrl) {
        this.urlType = 'iframe'
        this.isValidUrl = true
        return url
      }

      return this.isValidVideoUrl(url)
    },

    isValidVideoUrl(url) {
      const videoTypes = ['.mp4', '.ogg', '.webm']
      for (const i in videoTypes) {
        if (url.includes(videoTypes[i])) {
          this.urlType = 'video'
          this.isValidUrl = true
          return url
        }
      }
      this.isValidUrl = false
      return url
    },
  },
}
